import { State } from "src/state";

export const isCreditLensFeatureEnabled = (state: State) =>
  state.config.enableCreditLens;

export const isFlyoutReasonsFeatureEnabled = (state: State) =>
  state.config.enableFlyoutReasons;

export const getCreditLensPathPrefix = (state: State) =>
  state.config.creditLensPathPrefix;

export const getDocumentsPollInterval = (state: State) =>
  state.config.documentsPollIntervalMs;

export const isUnmappedAccountsFeatureEnabled = (state: State) =>
  state.config.unmappedAccountsEnabled;

export const isDbsJwtLoginEnabled = (state: State) =>
  state.config.dbsJwtLoginEnabled;

export const isDbsUploadButtonEnabled = (state: State) =>
  state.config.dbsUploadButtonEnabled;

export const getPageSize = (state: State) => state.config.pageSize;

export const getEnv = (state: State) => state.config.env;

export const getMetadataState = (state: State) => state.metadata;

export const isExportEnabled = (state: State) =>
  Boolean(state.clientMetadata.useExcelReport);

export const isSheetPerPeriod = (state: State) =>
  Boolean(state.clientMetadata.isSheetPerPeriod);

export const showRejectSpread = (state: State) => {
  return Boolean(state.clientMetadata.useRejectSpread);
};

export const showRejectSpreadPopup = (state: State) => {
  return Boolean(state.clientMetadata.useRejectSpreadOnPopup);
};



// WEBPACK FOOTER //
// ./src/configState/selector.ts